import React, {useEffect, useState} from "react";

const MobileNav = ({searchImagesTags, loadingTags, tagsData, handleScrollTop, oName}) => {
  const [searchSection, setSearchSection] = useState(false);
  const [realEvents, setRealEvents] = useState("Realevents");
  const [tga, setTga] = useState(false);
  const setParams = (url, tag_id) => {
    // if (ifFlag !== undefined && ifFlag == true) {
    let n = "/real-events";
    history.pushState({}, "", n + "/search?searchText=" + url + "&tag_id=" + tag_id);
    // }
    //  else {
    //   history.pushState({}, "", "search?searchText=" + url + "&tag_id=" + tag_id);
    // }
    // history.pushState({}, "", "search?searchText=" + url + "&tag_id=" + tag_id);
  };
  const handleReload = () => {
    window.location.reload();
  };
  return (
    <>
      <div
        id={searchSection == true ? "m-nav-5" : "m-nav-mobile"}
        onKeyDown={(e) => {
          if (e.keyCode === 13) {
            handleReload();
          }
        }}
      >
        <div id={searchSection == true ? "onz" : "on1"}>
          <img src="../../media/bArrow.svg" alt="BackArrow" onClick={() => handleScrollTop()} />
          {searchSection == true ? (
            <div id={tagsData?.length > 0 ? "s-e-h" : "search-e-h"}>
              <img src="../../media/blackSearch.svg" alt="Black Search Icon" />
              <input
                type="text"
                placeholder="Search"
                onChange={(e) => {
                  searchImagesTags(e.target.value);
                  setParams(e.target.value, "");
                }}
                onBlur={() => {
                  setTimeout(() => {
                    setTga(false);
                  }, 200);
                }}
                onFocus={() => setTga(true)}
              />
            </div>
          ) : (
            <span>
              {oName == undefined ? realEvents : oName.length > 15 ? oName?.slice(0, 15) : oName}
            </span>
          )}

          {tagsData?.length > 0 && tga == true && (
            <div className="search-options n-0">
              {loadingTags == true ? (
                <>
                  <div id="lodas">
                    <img src="../../media/Pino.svg" alt="Loading image" />
                  </div>
                </>
              ) : (
                <ul>
                  {tagsData?.length > 0 &&
                    tagsData !== undefined &&
                    tagsData?.map((t, i) => {
                      return (
                        <li
                          onClick={() => {
                            setParams(t.name, t.id);
                            handleReload();
                          }}
                        >
                          {t.name}
                        </li>
                      );
                    })}
                </ul>
              )}
            </div>
          )}
        </div>
        <div id="on2">
          {!searchSection && (
            <img
              src="../../media/blackSearch.svg"
              alt="Black Search Icon"
              onClick={() => setSearchSection(!searchSection)}
            />
          )}
          <a href="https://www.bookeventz.com/saved-albums" target="_blank">
            <img src="../../media/bHeart.svg" alt="Black Heart Icon" />
          </a>
        </div>
      </div>
    </>
  );
};

export default MobileNav;
